import { Stack, styled } from "@mui/material";

export const CustomerApprovalWrapper = styled(Stack)(() => {
	return {
		gap: "var(--flex-gap)",
		overflow: "hidden",
	};
});
